import { increaseFpClickCount } from '@/api/themedata'
export default {
  data() {
    return {
      fpClickCount: 0
    }
  },
  created() {
    increaseFpClickCount().then(res => {
      this.fpClickCount = res.data.data
    })
  }
}
